// extracted by mini-css-extract-plugin
export default {"form":"Form-module__form___oHnem","disabled":"Form-module__disabled___MAkbH"};